module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_yyy-a625e5e9918e95c69acd6535a0203d98.png";